export default __webpack_public_path__ + "banner-bgb5c7a5.jpg";